const { createContext } = require("react");

export const UserType = createContext();
